import { toast } from 'react-toastify'
import { useDotnetClient } from '@/contexts/DotnetClientContext'
import { useCallback, useMemo } from 'react'
import { createRestClient } from '@/contexts/QueryProvider'
import { useSessionStorage } from './useSessionStorage'

export function useLogout() {
  const { postAuthenticationApiLogout } = createRestClient()
  const { mutate: Logout } = postAuthenticationApiLogout.useMutation()
  const [sub] = useSessionStorage('sub', '')
  const [token] = useSessionStorage('token', '')
  const [isRefreshing] = useSessionStorage('isRefreshing', false)

  const logoutHandler = useCallback(() => {
    Logout(
      {},
      {
        onSuccess: () => {
          sessionStorage.clear()
          window.location.replace(`/?authStatus=logout-success`)
        },
        onError: () => {
          toast.warning('Logout failed', {
            toastId: 'logout-failed',
            autoClose: 500,
            hideProgressBar: false,
            closeOnClick: true,
          })
          // still clear everything, logout can fail it token is already old etc
          sessionStorage.clear()
          window.location.replace(`/?authStatus=logout-failed`)
        },
      }
    )
  }, [Logout])

  const logoutWithBeacon = useCallback(async () => {
    if (sub && token && !isRefreshing) {
      logoutHandler()
    }
  }, [isRefreshing, logoutHandler, sub, token])

  return useMemo(() => ({ logoutHandler, logoutWithBeacon }), [logoutHandler, logoutWithBeacon])
}

export function useFlushRedis() {
  const { dmpClient } = useDotnetClient()

  return () => {
    if (!dmpClient) return

    dmpClient.supportApi
      .getSupportApiFlushRedis()
      .then(() => {
        toast.info('Redis Flushed - You have been logged out.')
      })
      .catch((err) => {
        console.error(err)
        toast.warning('Redis flush failed')
      })
      .finally(() => {
        setTimeout(() => {
          sessionStorage.clear()
          window.location.replace(`/?authStatus=logout-success`)
        }, 2000)
      })
  }
}

export function useSetRedis() {
  const { dmpClient } = useDotnetClient()

  return (key: string, value: string) => {
    if (!dmpClient) return

    dmpClient.supportApi
      .getSupportApiSetRedis(key, value)
      .then(() => {
        toast.info('Redis value set')
      })
      .catch((err) => {
        console.error(err)
        toast.warning('Redis set value failed')
      })
      .finally(() => {})
  }
}
